export interface IDonorWithMSRecipientUpdated {
    id: number,
    remoteStatus: number,
    coordinatorId: number,
    comments: string
}